// extracted by mini-css-extract-plugin
export default {"activeLegend":"legend-icon-button_activeLegend__4ZjAM"};